"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Image = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var Image = function (_a) {
    var as = _a.as, fit = _a.fit, src = _a.src, _b = _a.alt, alt = _b === void 0 ? '' : _b, _c = _a.style, style = _c === void 0 ? {} : _c, className = _a.className, rest = __rest(_a, ["as", "fit", "src", "alt", "style", "className"]);
    if (fit) {
        var ariaProps = alt !== '' ? { role: 'img', 'aria-label': alt } : {};
        return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as || 'div', className: ['image', 'fit', className], style: __assign(__assign({}, style), (src && { backgroundImage: "url(\"" + src + "\")" })) }, ariaProps, rest)));
    }
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as || 'img', src: src, alt: alt, style: style, className: ['image', className], loading: "lazy" }, rest)));
};
exports.Image = Image;
//# sourceMappingURL=Image.js.map